import { ScopeOption } from '../types';

/** Зона по аптекам: что оператор видит в реестре и сводке «Табеля РБ» */
const zoneScope = (what: string): ScopeOption[] => [
  { value: 'all', label: 'Вся сеть', description: `${what}: все аптеки сети`, badgeColor: '#10b981' },
  { value: 'assigned_pharmacies', label: 'Курируемые аптеки', description: `${what}: аптеки из myPharmacy оператора`, badgeColor: '#3b82f6' },
  { value: 'own_region', label: 'Свой регион', description: `${what}: аптеки своего города (cityId)`, badgeColor: '#06b6d4' },
  { value: 'none', label: 'Запрещено', description: `${what}: нет доступа`, badgeColor: '#ef4444' }
];

/**
 * Варианты скоупов для модуля «Табель РБ» (timesheet.*)
 */
export const timesheetScopes: Record<string, ScopeOption[]> = {
  // Вывод данных: аптеки в реестре и сводке (зона применяется ко всем зависимым операциям)
  'timesheet.data': zoneScope('Данные табелей'),

  // Кнопка перехода: в табели каких аптек можно перейти (дополнительно сужает зону вывода данных)
  'timesheet.open': zoneScope('Переход в табель')
  // timesheet.menu и timesheet.settings скоупов не имеют - только тумблер
};
